<template>
  <div class="filter-elements">
    <div class="search-container" v-if="itemStore.showSearch">
      <input type="search" :placeholder="t('search')" v-model="itemStore.search" @keyup="changeSearch"
             @keydown="checkEnter"/>
    </div>
    <button :class="getClass()" @click="itemStore.toggleSort()" v-if="itemStore.showSort">
      ABC
    </button>
    <MonthButtons v-if="itemStore.showMonth"/>
    <template v-if="itemStore.taxonomy.primary">
      <FilterButton v-if="itemStore.filterRadio" :term="all" :taxonomy="itemStore.taxonomy.primary"/>
      <FilterButton v-for="term in itemStore.getPrimary" :key="term.slug" :term="term" :taxonomy="itemStore.taxonomy.primary"/>
    </template>
  </div>
  <div v-if="itemStore.taxonomy.secondary" class="filter-elements second-row">
    <FilterButton v-if="itemStore.filterRadio" :term="all" :taxonomy="itemStore.taxonomy.secondary"/>
    <FilterButton v-for="term in itemStore.getSecondary" :key="term.slug" :term="term" :taxonomy="itemStore.taxonomy.secondary"/>
  </div>
</template>


<script setup lang="ts">
import {useItemStore} from "@/itemStore";
import type {Term} from "@/itemStore";
import FilterButton from "@/components/FilterButton.vue";
import {searchPosts} from "@/fetch";
import MonthButtons from "@/components/MonthButtons.vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n();

const itemStore = useItemStore();
const components = {FilterButton}

const all = {id:0,slug:'',name: t('all'), order:0, children: []} as Term;

let timer = 0;

const checkEnter = (e: KeyboardEvent) => {
  // Prevent submit on enter.
  return e.key !== 'Enter';
}

const changeSearch = (e: KeyboardEvent) => {
  clearTimeout(timer);
  if (e.key === 'Enter') {
    // Search right away on Enter.
    doSearch();
  } else {
    // Delayed search on other buttons.
    timer = setTimeout(() => {
      doSearch();
    }, 700);
  }
}

const doSearch = () => {
  if (itemStore.search.length > 0) {
    itemStore.resetShow();
    searchPosts();
  }
}

const getClass = () => {
  let className = "btn sort";
  if (itemStore.sort) {
    className += itemStore.asc ? " asc" : " desc";
  }
  return className;
}

</script>

<style lang="scss">
.filter-container {
  padding-bottom: 1.5rem;
}

.filter-elements {
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;

  > * {
    flex: 0 0 auto;
  }
}
</style>
